import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, resolveComponent as _resolveComponent, createVNode as _createVNode, createTextVNode as _createTextVNode, renderList as _renderList, Fragment as _Fragment, toDisplayString as _toDisplayString, normalizeClass as _normalizeClass, withCtx as _withCtx, createBlock as _createBlock, mergeProps as _mergeProps } from "vue"

const _hoisted_1 = {
  key: 0,
  class: "loader-overlay"
}
const _hoisted_2 = { class: "ma-1 mt-2 text-h5" }
const _hoisted_3 = { class: "ma-1 mt-2 text-h5" }
const _hoisted_4 = {
  class: "flex-grow-1",
  style: {"overflow-y":"auto"}
}
const _hoisted_5 = { class: "ma-1 mt-2 text-h5" }
const _hoisted_6 = {
  class: "flex-grow-1",
  style: {"overflow-y":"auto"}
}
const _hoisted_7 = { class: "ma-1 mt-2 text-h5" }
const _hoisted_8 = {
  class: "flex-grow-1",
  style: {"overflow-y":"auto"}
}
const _hoisted_9 = ["src"]
const _hoisted_10 = { style: {"position":"absolute","bottom":"0px","left":"10px","font-size":"20px"} }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_v_icon = _resolveComponent("v-icon")!
  const _component_v_list_item_title = _resolveComponent("v-list-item-title")!
  const _component_v_list_item = _resolveComponent("v-list-item")!
  const _component_v_list = _resolveComponent("v-list")!
  const _component_v_card = _resolveComponent("v-card")!
  const _component_v_col = _resolveComponent("v-col")!
  const _component_v_hover = _resolveComponent("v-hover")!
  const _component_v_row = _resolveComponent("v-row")!
  const _component_ImageZoomOverlay = _resolveComponent("ImageZoomOverlay")!
  const _component_v_snackbar = _resolveComponent("v-snackbar")!
  const _component_v_container = _resolveComponent("v-container")!

  return (_openBlock(), _createBlock(_component_v_container, {
    fluid: "",
    class: "pa-0 fill-height",
    style: {"background-color":"#20242f","position":"relative"}
  }, {
    default: _withCtx(() => [
      (_ctx.fetchingPatients)
        ? (_openBlock(), _createElementBlock("div", _hoisted_1, _cache[2] || (_cache[2] = [
            _createElementVNode("div", { class: "loader-spinner" }, null, -1)
          ])))
        : _createCommentVNode("", true),
      _createVNode(_component_v_row, {
        "no-gutters": "",
        class: "fill-height",
        align: "center",
        justify: "center"
      }, {
        default: _withCtx(() => [
          _createVNode(_component_v_col, { cols: "2" }, {
            default: _withCtx(() => [
              _createVNode(_component_v_card, {
                height: "100vh",
                width: "100%",
                style: {"overflow":"auto"}
              }, {
                default: _withCtx(() => [
                  _createElementVNode("p", _hoisted_2, [
                    _createVNode(_component_v_icon, {
                      icon: "mdi-account",
                      class: "mb-1"
                    }),
                    _cache[3] || (_cache[3] = _createTextVNode(" Patients "))
                  ]),
                  _cache[4] || (_cache[4] = _createElementVNode("hr", null, null, -1)),
                  _createVNode(_component_v_list, null, {
                    default: _withCtx(() => [
                      (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.sortBy(_ctx.patients, ['id']), (item, i) => {
                        return (_openBlock(), _createBlock(_component_v_list_item, {
                          key: i,
                          class: _normalizeClass({ 'bg-blue text-white': item.id === _ctx.patient?.id }),
                          value: item,
                          onClick: ($event: any) => (_ctx.selectPatient(item))
                        }, {
                          default: _withCtx(() => [
                            _createVNode(_component_v_list_item_title, {
                              textContent: _toDisplayString(item.id)
                            }, null, 8, ["textContent"])
                          ]),
                          _: 2
                        }, 1032, ["class", "value", "onClick"]))
                      }), 128))
                    ]),
                    _: 1
                  })
                ]),
                _: 1
              })
            ]),
            _: 1
          }),
          _createVNode(_component_v_col, { cols: "10" }, {
            default: _withCtx(() => [
              _createVNode(_component_v_row, {
                "no-gutters": "",
                align: "center",
                justify: "center"
              }, {
                default: _withCtx(() => [
                  _createVNode(_component_v_col, { cols: "11" }, {
                    default: _withCtx(() => [
                      _createVNode(_component_v_row, {
                        "no-gutters": "",
                        align: "center",
                        justify: "center"
                      }, {
                        default: _withCtx(() => [
                          _createVNode(_component_v_col, {
                            cols: "6",
                            class: "pr-2",
                            style: {"height":"25vh"}
                          }, {
                            default: _withCtx(() => [
                              _createVNode(_component_v_card, {
                                class: "d-flex flex-column",
                                style: {"height":"100%"}
                              }, {
                                default: _withCtx(() => [
                                  _createElementVNode("div", null, [
                                    _createElementVNode("p", _hoisted_3, [
                                      _createVNode(_component_v_icon, {
                                        icon: "mdi-map-marker-account",
                                        class: "mb-1"
                                      }),
                                      _cache[5] || (_cache[5] = _createTextVNode(" Lesions "))
                                    ]),
                                    _cache[6] || (_cache[6] = _createElementVNode("hr", null, null, -1))
                                  ]),
                                  _createElementVNode("div", _hoisted_4, [
                                    _createVNode(_component_v_list, null, {
                                      default: _withCtx(() => [
                                        (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.sortBy(_ctx.patient?.lesions, ['id']), (item, i) => {
                                          return (_openBlock(), _createBlock(_component_v_list_item, {
                                            key: i,
                                            class: _normalizeClass({ 'bg-blue text-white': item.id === _ctx.lesion?.id }),
                                            onClick: ($event: any) => (_ctx.selectLesion(item))
                                          }, {
                                            default: _withCtx(() => [
                                              _createVNode(_component_v_list_item_title, {
                                                textContent: _toDisplayString(item.id)
                                              }, null, 8, ["textContent"])
                                            ]),
                                            _: 2
                                          }, 1032, ["class", "onClick"]))
                                        }), 128))
                                      ]),
                                      _: 1
                                    })
                                  ])
                                ]),
                                _: 1
                              })
                            ]),
                            _: 1
                          }),
                          _createVNode(_component_v_col, {
                            cols: "6",
                            class: "pl-2",
                            style: {"height":"25vh"}
                          }, {
                            default: _withCtx(() => [
                              _createVNode(_component_v_card, {
                                class: "d-flex flex-column",
                                style: {"height":"100%"}
                              }, {
                                default: _withCtx(() => [
                                  _createElementVNode("div", null, [
                                    _createElementVNode("p", _hoisted_5, [
                                      _createVNode(_component_v_icon, {
                                        icon: "mdi-folder-multiple-image",
                                        class: "mb-1"
                                      }),
                                      _cache[7] || (_cache[7] = _createTextVNode(" Exams "))
                                    ]),
                                    _cache[8] || (_cache[8] = _createElementVNode("hr", null, null, -1))
                                  ]),
                                  _createElementVNode("div", _hoisted_6, [
                                    _createVNode(_component_v_list, null, {
                                      default: _withCtx(() => [
                                        (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.sortBy(_ctx.lesion?.exams, ['id']), (item, i) => {
                                          return (_openBlock(), _createBlock(_component_v_list_item, {
                                            key: i,
                                            class: _normalizeClass({ 'bg-blue text-white': item.id === _ctx.exam?.id }),
                                            value: item,
                                            onClick: ($event: any) => (_ctx.exam = item)
                                          }, {
                                            default: _withCtx(() => [
                                              _createVNode(_component_v_list_item_title, {
                                                textContent: _toDisplayString(item.id)
                                              }, null, 8, ["textContent"])
                                            ]),
                                            _: 2
                                          }, 1032, ["class", "value", "onClick"]))
                                        }), 128))
                                      ]),
                                      _: 1
                                    })
                                  ])
                                ]),
                                _: 1
                              })
                            ]),
                            _: 1
                          }),
                          _createVNode(_component_v_col, {
                            cols: "12",
                            class: "mt-4",
                            style: {"height":"65vh"}
                          }, {
                            default: _withCtx(() => [
                              _createVNode(_component_v_card, {
                                height: "100%",
                                class: "d-flex flex-column"
                              }, {
                                default: _withCtx(() => [
                                  _createElementVNode("div", null, [
                                    _createElementVNode("p", _hoisted_7, [
                                      _createVNode(_component_v_icon, {
                                        icon: "mdi-image",
                                        class: "mb-1"
                                      }),
                                      _cache[9] || (_cache[9] = _createTextVNode(" Acquisitions "))
                                    ]),
                                    _cache[10] || (_cache[10] = _createElementVNode("hr", null, null, -1))
                                  ]),
                                  _createElementVNode("div", _hoisted_8, [
                                    (_ctx.exam && _ctx.exam.acquisitions.length)
                                      ? (_openBlock(), _createBlock(_component_v_row, {
                                          key: 0,
                                          "no-gutters": "",
                                          class: "my-1"
                                        }, {
                                          default: _withCtx(() => [
                                            (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.sortBy(_ctx.exam.acquisitions, ['id']), (item, i) => {
                                              return (_openBlock(), _createBlock(_component_v_col, {
                                                key: i,
                                                cols: "12",
                                                sm: "6",
                                                md: "4",
                                                lg: "3",
                                                class: "text-center"
                                              }, {
                                                default: _withCtx(() => [
                                                  (item.medias.thumbnailURL && item.medias.fullResolutionURL)
                                                    ? (_openBlock(), _createBlock(_component_v_hover, { key: 0 }, {
                                                        default: _withCtx(({ isHovering, props }) => [
                                                          _createVNode(_component_v_card, _mergeProps({ ref_for: true }, props, {
                                                            elevation: isHovering ? 8 : 2,
                                                            class: "cursor-pointer my-2",
                                                            style: {"width":"100%","height":"260px"},
                                                            onClick: ($event: any) => {_ctx.selectImage(item.medias.fullResolutionURL);}
                                                          }), {
                                                            default: _withCtx(() => [
                                                              _createElementVNode("img", {
                                                                src: item.medias.thumbnailURL,
                                                                style: {"max-width":"95%","max-height":"90%","object-fit":"contain"}
                                                              }, null, 8, _hoisted_9),
                                                              _createElementVNode("p", _hoisted_10, [
                                                                _createElementVNode("b", null, "IM 00" + _toDisplayString(item.id), 1),
                                                                _createTextVNode(" - " + _toDisplayString(item.details.date) + " " + _toDisplayString(_ctx.formatTime(item.details.time)), 1)
                                                              ])
                                                            ]),
                                                            _: 2
                                                          }, 1040, ["elevation", "onClick"])
                                                        ]),
                                                        _: 2
                                                      }, 1024))
                                                    : _createCommentVNode("", true)
                                                ]),
                                                _: 2
                                              }, 1024))
                                            }), 128))
                                          ]),
                                          _: 1
                                        }))
                                      : _createCommentVNode("", true)
                                  ])
                                ]),
                                _: 1
                              })
                            ]),
                            _: 1
                          })
                        ]),
                        _: 1
                      })
                    ]),
                    _: 1
                  })
                ]),
                _: 1
              })
            ]),
            _: 1
          }),
          _createVNode(_component_ImageZoomOverlay, {
            modelValue: _ctx.imageSelected,
            "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((_ctx.imageSelected) = $event)),
            images: [{
                    src: _ctx.imageURLSelected,
                    title: 'Image'
                }]
          }, null, 8, ["modelValue", "images"]),
          _createVNode(_component_v_snackbar, {
            modelValue: _ctx.showSnackbar,
            "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((_ctx.showSnackbar) = $event)),
            color: _ctx.snackbarColor,
            timeout: "3000"
          }, {
            default: _withCtx(() => [
              _createTextVNode(_toDisplayString(_ctx.snackbarMessage), 1)
            ]),
            _: 1
          }, 8, ["modelValue", "color"])
        ]),
        _: 1
      })
    ]),
    _: 1
  }))
}